<div class="wrapper">
    <div class="loading">
        <img src="assets/diamond_img/loading.gif" alt="" class="mCS_img_loaded">
    </div>
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-md-10 report-main-content m-t-5">
                    <div class="card">
                        <div class="card-header">
                          <h4 class="mb-0">Change Button Values</h4>
                        </div>
                        <div class="card-body container-fluid container-fluid-5 button-value">
                            <div class="row row5 mb-1">
                                <div class="col-6 col-md-3">
                                    <div class="button-title">
                                        <span><b>Price Label</b></span>
                                    </div>
                                </div>
                                <div class="col-6 col-md-3">
                                    <div class="button-title" style="padding-left: 5px;">
                                        <span><b>Price Value</b></span>
                                    </div>
                                </div>
                            </div>
                            <div class="row row5 mb-1" *ngFor="let stack of userMatchStack?.match_stack;let k=index;trackBy:trackByFn">
                                <div class="col-6 col-md-3">
                                    <div class="form-group mb-0 ml-0">
                                        <input placeholder="Button Name" type="number" class="form-control" [value]="stack" [(ngModel)]="match_stack[k]" name="stack_value" [ngModelOptions]="{standalone: true}">
                                    </div>
                                </div>
                                <div class="col-6 col-md-3">
                                    <div class="form-group mb-0 mr-0">
                                        <input placeholder="Button Value" type="number" class="form-control" [value]="stack" [(ngModel)]="match_stack[k]" name="stack_value" [ngModelOptions]="{standalone: true}">
                                    </div>
                                </div>
                            </div>
                            <div class="row row5 mt-2">
                                <div class="col-12">
                                    <button type="submit" class="btn btn-primary" (click)="updateUserMatchStack()">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>